import { render, staticRenderFns } from "./_base-input.vue?vue&type=template&id=93c28e6a&scoped=true&"
import script from "./_base-input.vue?vue&type=script&lang=js&"
export * from "./_base-input.vue?vue&type=script&lang=js&"
import style0 from "./_base-input.vue?vue&type=style&index=0&id=93c28e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93c28e6a",
  null
  
)

export default component.exports